<div>
	<form [formGroup]="formGroup">
		<div class="row">
			<div class="col-sm-6">
				<app-form-field [type]="fields.start.type" [options]="fields.start.options"></app-form-field>
			</div>
			<div class="col-sm-6">
				<app-form-field [type]="fields.end.type" [options]="fields.end.options"></app-form-field>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-12">
				<app-form-field [type]="fields.groups_id.type" [options]="fields.groups_id.options"></app-form-field>
			</div>
		</div>
	</form>
	<a href="{{link}}" target="_blank" rel="noopener noreferrer" #myDiv></a>
</div>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="formGroup.invalid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
